import MessageBus from '@gaming/mtt-postal-kit';
import { v4 as uuid } from 'uuid';

export const request = envelope =>
  new Promise((resolve, reject) => {
    const replyTopic = uuid();
    const responseSubscription = MessageBus.subscribe({
      topic: replyTopic,
      callback(responseData, responseEnvelope) {
        MessageBus.unsubscribe(responseSubscription);
        if (responseEnvelope.headers.status !== 'OK')
          return reject(responseData.errorMessage);
        return resolve(responseData, responseEnvelope);
      },
    });

    MessageBus.publish({
      ...envelope,
      headers: { ...envelope.headers, replyTopic },
    });
  });

export const listen = ({ topic, callback }) =>
  MessageBus.subscribe({
    topic,
    callback(_, envelope) {
      const {
        headers: { replyTopic },
      } = envelope;

      const replyOK = (replyData, replyHeaders = {}) => {
        MessageBus.publish({
          topic: replyTopic,
          headers: { ...replyHeaders, status: 'OK' },
          data: replyData,
        });
      };

      const replyError = (errorMessage = '', replyHeaders = {}) => {
        MessageBus.publish({
          topic: replyTopic,
          headers: { ...replyHeaders, status: 'ERROR' },
          data: { errorMessage },
        });
      };

      callback(envelope, replyOK, replyError);
    },
  });
